import { AsyncPipe } from '@angular/common';
import { ChangeDetectorRef, Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormsModule } from '@angular/forms';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { map } from 'rxjs';
import { TopNavFilterConfig } from '../../../core/model/common';
import { FarmState } from '../../../core/services/states/farm.service';
import { TopNavState } from '../../../core/services/states/topnav.service';

@Component({
  selector: 'header-farm',
  template: `
    <nz-select
      class="top-nav-select"
      [ngModel]="(farmState.get$() | async)?.farmId"
      (ngModelChange)="onChange($event)"
      style="opacity: 0.9; width: 150px;"
      [hidden]="!showFarmSelector"
    >
      @for (item of farmState.getFarmList$() | async; track $index) {
        <nz-option [nzValue]="item.farmId" [nzLabel]="item.farmName"></nz-option>
      } @empty {}
    </nz-select>
  `,
  host: {
    '[class.flex-1]': 'true'
  },
  imports: [NzIconModule, NzSelectModule, FormsModule, AsyncPipe]
})
export class HeaderFarmComponent implements OnInit {
  protected destroyRef = inject(DestroyRef);
  protected farmState = inject(FarmState);
  protected topNavState = inject(TopNavState);
  protected showFarmSelector: boolean = true;

  constructor(private changeDetector: ChangeDetectorRef) {}
  ngOnInit(): void {
    this.farmState.initFarmList();

    this.topNavState.topNav$
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((config: TopNavFilterConfig) => config.showFarmSelector) // Extract showFarmSelector
      )
      .subscribe((showFarmSelector: boolean) => {
        if (this.showFarmSelector != showFarmSelector) {
          this.showFarmSelector = showFarmSelector;
          this.changeDetector.detectChanges();
        }
      });
  }

  onChange(farmId: number) {
    const selectedFarm = this.farmState.getFarmList().find(farm => farm.farmId === farmId);
    if (selectedFarm) {
      this.farmState.setState(selectedFarm);
      this.changeDetector.detectChanges();
    }
  }
}
